import Message from '../interfaces/Message';

export const createUserMessage = (text: string, sender='human'): Message => ({
  id: `user_${Date.now()}`,
  text,
  sender: sender,
  timestamp: new Date(),
});

export const createBotMessage = (text: string, suggestedCustomizations?: string[], id: number | undefined = undefined): Message => ({
  id: id?.toString() ?? `bot_${Date.now()}`,
  text,
  sender: 'ai',
  timestamp: new Date(),
  suggestedCustomizations,
});

export const generateChatTitle = (text: string): string => {
  const maxLength = 25;
  return text.length > maxLength ? `${text.substring(0, 22)}...` : text;
};

export const formatTimestamp = (timestamp: Date): string => {
  return timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};